import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Fire-and-forget page view tracker. Mounts once at the root and
 * pings the analytics endpoint on every route change.
 */
function getVisitorId() {
  try {
    let v = localStorage.getItem('rr_visitor_id');
    if (!v) {
      v = `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem('rr_visitor_id', v);
    }
    return v;
  } catch {
    return null;
  }
}

export function PageViewTracker() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    // Skip admin/preview auto-visits
    const path = location.pathname + (location.search || '');
    if (path.startsWith('/admin')) return;

    const payload = {
      path,
      referrer: document.referrer || null,
      visitor_id: getVisitorId(),
      user_id: user?.id || null,
    };

    // Use fetch with keepalive so the request survives navigation
    fetch(`${API}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => { /* swallow */ });
  }, [location.pathname, location.search, user?.id]);

  return null;
}
